<div class="year-wrapper">
  <app-menu-year [months]="months" [current]="currentMonth.index" (change)="changeMonth($event)"></app-menu-year>
</div>

<div class="center-wrapper">
  <div class="header">
    <div class="header-date-picker">
      <a class="date--prev" *ngIf="prevMonth" [routerLink]="['/menu/month', prevMonth]"></a>
      <app-title icon="menu_over">
        Jedilniki: {{ currentMonth.first.format('MMMM') }}
      </app-title>
      <a class="date--next" *ngIf="nextMonth" [routerLink]="['/menu/month', nextMonth]"></a>
    </div>
    <button class="btn-menu-copy btn-menu-copy--multiline" (click)="copyClick()" [disabled]="copyMode !== 'none'" tooltip="Kopiraj jedilnik določenih dni za ponovno uporabo v drugih tednih ali mesecih">
      Kopiraj izbrane&#10;dneve jedilnika
    </button>
    <app-select-button>
      <button class="btn-report btn-report--multiline">
        Natisni jedilnik za&#10;oglasno desko
      </button>
      <select (change)="reportBasicMenu($event)" tooltip="Kratek pregled jedilnika – primeren za prikaz na oglasni deski ali spletni strani zavoda.">
        <option disabled selected></option>
        <option [value]="diet.id" *ngFor="let diet of diets">{{ diet.name }}</option>
      </select>
    </app-select-button>
    <app-select-button>
      <button class="btn-report btn-report--multiline">
        Natisni hranilno&#10;analizo jedilnika
      </button>
      <select (change)="reportExtendedMenu($event)" tooltip="Mesečni jedilnik z energijskimi vrednostmi in hranili po dnevih, tednih in povprečno na mesec.">
        <option disabled selected></option>
        <option [value]="diet.id" *ngFor="let diet of diets">{{ diet.name }}</option>
      </select>
    </app-select-button>
    <app-select-button>
      <button class="btn-report btn-report--multiline">
        Natisni analizo&#10;pogostosti živil
      </button>
      <select (change)="reportDetailedMenu($event)" tooltip="Prikaz, kako pogosto se določena živila pojavljajo v jedilniku, skupaj s primerjavo s smernicami.">
        <option disabled selected></option>
        <option [value]="diet.id" *ngFor="let diet of diets">{{ diet.name }}</option>
      </select>
    </app-select-button>
<!--    <div class="month-summary">-->
<!--      <span>Povprečna cena na dan:</span>-->
<!--      <span>-->
<!--        <ng-container *ngIf="avgCost">-->
<!--          {{ avgCost | number:'1.0-2' }} €-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!avgCost">-</ng-container>-->
<!--      </span>-->
<!--      <span>Delež ekoloških izdelkov:</span>-->
<!--      <span>-->
<!--        <ng-container *ngIf="ecoRatio">-->
<!--          {{ ecoRatio | percent }}-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!ecoRatio">-</ng-container>-->
<!--      </span>-->
<!--    </div>-->
    <app-toggle-help>
      <p>
        Jedilniki so urejeni po mesecih, vnašate jih lahko po dnevih in skupinah uporabnikov. Potrjeni dnevi so obarvani zeleno. V dnevnem pogledu lahko v stolpcih »Tedenska pogostnost« in »Dnevno povprečje« spremljate skladnost jedilnika s prehranskimi smernicami. Siva barva označuje skupine živil, ki jih še niste vključili. Potrjevanje jedilnika za posamezno skupino naročnikov poteka v dnevnem pogledu jedilnika.
      </p>
    </app-toggle-help>
  </div>

  <div class="white-container">
    <app-meal-size-picker [sizes]="availableSizes" [selectedSize]="selectedSize" (selected)="sizeSelected($event)" [sizeStatuses]="sizeStatuses"></app-meal-size-picker>
    <div class="container">
      <div class="month-container">
        <div class="month" [ngClass]="copyMode">
          <div class="head" *ngFor="let day of weekDays">
            {{ day }}
          </div>
          <div class="head head-week">
            Tedenska pogostost
            <span class="help-tooltip" tooltip="Tedenska pogostnost prikazuje, kolikokrat na teden se posamezna skupina živil pojavi v jedilnikih."></span>
          </div>

          <ng-container *ngFor="let day of currentMonth.days; let index = index">
            <div [class]="dayClass(day)" [class.today]="day.isToday" [class.selected]="selectedDays.has(day.date)">
          <span *ngIf="day.current" (click)="dayClick(day)" (mouseover)="dayOver(day)" (mouseout)="dayOut()">
            {{ day.index }}
          </span>
              <a *ngIf="index % 7 === 0" [routerLink]="['/menu/week', day.week]">{{ day.week }}</a>
            </div>
            <ng-container *ngIf="day.isSunday">
              <div class="week" [routerLink]="['/menu/week', day.week]">
                <app-pyramide-compact [units]="weekCategories.get(day.week)" [showLabels]="false" counts="true"></app-pyramide-compact>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div *ngIf="copyMode === 'copy'" class="copy-select">
          <span>1.) V koledarju označite željene dni in kliknite na gumb Kopiraj.</span>
          <div class="source-year" *ngIf="availableYears?.length>1">
            <span>2.) Izberite šolsko leto</span>
            <select (change)="selectCopyYear($event)">
              <option *ngFor="let year of availableYears" [selected]="year.yearId === sourceCopyYearId" [value]="year.yearId">{{year.year}}/{{year.year+1}}</option>
            </select>
          </div>
          <button (click)="copyClick()" [disabled]="selectedDays.size === 0"><i class="icon-copy"></i> Kopiraj</button>
          <button (click)="copyCancel()"><i class="icon-close"></i> Prekliči</button>
        </div>
        <div *ngIf="copyMode === 'pick' || copyMode === 'paste'" class="copy-select">
          <span>2.) V koledarju označite željeno lokacijo in kliknite na gumb Prilepi.</span>
          <button (click)="copyClick()" [disabled]="copyMode === 'pick'"><i class="icon-copy"></i> Prilepi</button>
          <button (click)="copyCancel()"><i class="icon-close"></i> Prekliči</button>
        </div>
        <div class="menu-legend">
          <i class="current"></i>
          <span>Prost dan</span>
          <i class="bare"></i>
          <span>Neizpolnjen jedilnik</span>
          <i class="invalid"></i>
          <span>Nepotrjen jedilnik</span>
          <i class="completed"></i>
          <span>Potrjen jedilnik</span>
        </div>
      </div>
      <div class="daily-average">
        <div class="daily-average--title">
          Dnevno povprečje
          <span class="help-tooltip" tooltip="Dnevno povprečje prikazuje, koliko posamezne skupine živil je vključene v jedilnik na dan, izraženo v povprečju za izbrani mesec."></span>
        </div>
        <app-pyramide-vertical [units]="monthUnits" [guidelines]="menuGuidelines.categories"></app-pyramide-vertical>

        <div *ngIf="avgCost" class="avg-price">
          <strong>Povprečna cena obroka</strong><br />
          vašega zavoda<br />
          na mesečni ravni<br />
          <strong>{{ avgCost | number:'1.2-2' }} €</strong>
        </div>
      </div>
    </div>
  </div>

</div>
